import {combineReducers} from 'redux';

import mediaOrdersItem from '../../MediaOrders/MediaOrdersItem/Redux/MediaOrdersItemReducer';
import mediaOrdersList from '../../MediaOrders/MediaOrdersList/Redux/MediaOrdersListReducer';

const mediaOrdersStore = combineReducers({
    mediaOrdersList,
    mediaOrdersItem,
});

export default mediaOrdersStore;
